var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.LangChanger}},[_c('v-list-item-icon',{staticClass:"me-2"},[_c('v-icon',{attrs:{"size":"22"}},[_vm._v(" mdi-web ")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('lang')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }